export default {
  buttons: {
    cancel: "Zrušiť",
    dismiss: "Zavrieť",
    add_waypoint: "pridajte cieľ"
  },
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  search: {
    title: "Vyhľadať",
    placeholder: "Zadajte miesto",
    enter_location: "Zadajte miesto",
    help: {
      inactive: "Vyhľadať"
    }
  },
  filters: {
    title: "Filtre",
    amenities: {
      title: "Služby a vybavenie"
    },
    fuels: {
      title: "Druhy palív"
    }
  },
  directions: {
    title: "Plánovač trasy",
    placeholder: {
      destination: "Zadajte miesto",
      waypoint: "Zadajte miesto"
    },
    route: {
      title: "Možnosti trasy",
      avoid_tolls: "Vynechať platené úseky",
      avoid_highways: "Vynechať diaľnice",
      title_corridor: "Vzdialenosť k čerpacej stanici (km)"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# deň} other {# dni}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# min}}\
`,
    button: "Vyhľadať"
  },
  locations: {
    title: "oblasti",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} z  {place}"
  },
  open_now: {
    open_24_hours: "Otvorené 24 hodín"
  },
  info_window: {
    title: "Detaily stanice",
    services: "Služby a vybavenie",
    nearby: "V blízkosti",
    opening_hours: {
      title: "Otváracie hodiny",
      mon: "Pon",
      tue: "Ut",
      wed: "Str",
      thu: "Štv",
      fri: "Pia",
      sat: "So",
      sun: "Ne",
      open_twentyfourhours: "Otvorené 24 hodín",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Posledná aktualizácia",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Plánovač trasy"
  },
  fuels: {
    fuelsave_midgrade_gasoline: "Shell FuelSave Natural 95",
    fuelsave_regular_diesel: "Shell FuelSave Diesel",
    premium_diesel: "Shell V-Power Diesel",
    premium_gasoline: "Shell V-Power",
    super_premium_gasoline: "Shell V-Power Racing"
  },
  amenities: {
    air_and_water: "Vzduch",
    atm: "Bankomat",
    austrian_highway_sticker: "Diaľničná známka Rakúsko",
    bottled_gas: "Výmena PB fliaš",
    cafe: "Kaviareň",
    carwash: "Umyváreň",
    clubsmart_card: "Karta Club Smart",
    credit_card_american_express: "Kreditná karta AMEX",
    credit_card_diners_club: "Kreditná karta Diners",
    credit_card_mastercard: "Kreditná karta Mastercard",
    credit_card_visa: "Kreditná karta VISA",
    credit_card: "Kreditná karta",
    czech_highway_sticker: "Diaľničná známka Česká republika",
    fleet_card_dkv: "Palivová karta - DKV",
    fleet_card_eni: "Palivová karta - ENI",
    fleet_card_esso: "Palivová karta - ESSO",
    fleet_card_general: "Palivová karta",
    fleet_card_uta: "Palivová karta - UTA",
    food_offerings: "Ponuka jedla",
    full_service: "Všetky služby/ Využité služby",
    guarded_car_park: "Strážené parkovisko",
    hgv_lane: "Vhodná i pre nákladné autá",
    high_speed_diesel_pump: "Rýchlovýdaj",
    hot_food: "Teplé jedlo",
    hungarian_highway_sticker: "Diaľničná známka Maďarsko",
    maut_terminal: "Mýtny terminál",
    mobile_payment: "Mobilné platenie",
    parking_lanes: "Parkovisko",
    partner_loyalty_accepted: "Partner Vernostný akceptovaný",
    pay_at_pump: "Platba pri stojane",
    quick_lubes: "Rychloservis",
    restaurant: "Restaurace",
    self_service: "Samoobsluha",
    service_bay: "Servis",
    shop: "Predajňa",
    shower: "Sprcha",
    slovak_highway_sticker: "Diaľničná známka Slovensko",
    snack_food: "Rýchle občerstvenie",
    standard_toilet: "Toalety",
    supermarket_fuel_discount: "Zľava na palivo",
    toilet: "Toalety",
    truck_parking: "Parkovanie pre nákladné autá",
    truckport: "Iba pre nákladné autá",
    twenty_four_hour: "24 hodín",
    vacuum: "Vysávač"
  },
  settings: {
    title: "Nastavenia",
    tooltip: "Nastavenia",
    distance_units: {
      title: "Vzdialenosť ",
      km: "kilometre",
      miles: "míle"
    },
    language: {
      title: "Jazyk"
    }
  }
}
